<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-angle-double-right"></i> Movimentação de Cards - Board</h3>
      </div>
    </div>
    <MovimentationAdd v-if="showAdd" ref="MovimentationAdd" v-on:Back="onBack" />
    <MovimentationList v-else ref="MovimentationList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
// import MovimentationAdd from './components/add/MovimentationAdd.vue'
import MovimentationAdd from './components/add/MovimentationAdd'
import MovimentationList from './components/list/MovimentationList.vue'

export default {
  name: 'CardMovimentation',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    MovimentationAdd,
    MovimentationList
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.MovimentationAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.MovimentationList.onLoad()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/cardMovimentation/CardMovimentation.vue